import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import about from "../assets/new-images/about.webp";
import about2 from "../assets/images_new/vision.webp";
const About = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>About Us</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section about-page">
        <Container>
          <Row>
            <Col xs={12} md={5} data-aos="fade-right">
              <img src={about} className="img-fluid img-animation" alt="Hive Employee Transportation And Cab Services"></img>
            </Col>
            <Col xs={12} md={7} data-aos="fade-left">
              <div className="main-title mt-3">
                <h4>Who we are</h4>
              </div>
              <p>
                Welcome to Hive Employee Transportation And Cab Services, 
                our story began with a fleet of 500+ vehicles in the vibrant city
                of Hyderabad.
              </p>
              <p>
                Today, we proudly serve a diverse clientele, from esteemed
                corporate partners to adventurous vacationers. Our offerings
                include seamless Car Rentals, reliable Employee Transport,
                expert Event Planning, and bespoke Holiday Escapes.
              </p>
              <p>
                At Hive Employee Transportation And Cab Services, our commitment to exceptional service
                and client satisfaction sets us apart. With our seasoned team of
                professionals, we ensure that each journey isn't just a trip but
                a cherished memory, brimming with comfort and convenience.
              </p>
              <p>
                As we continue to grow, our core values of integrity,
                reliability, and excellence remain unwavering. With a bold
                vision to lead the travel industry, we're dedicated to
                innovating and enhancing the travel experience for all our
                valued customers.
              </p>
            </Col>
          </Row>
          <Row className="mt-30 mb-30">
            <Col xs={12} md={5}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={7} data-aos="fade-right">
              <div className="main-title pt-60 mb-4">
                <h4>OUR VISION, MISSION:</h4>
              </div>
              <h5>MISSION</h5>
              <p>
              Our mission at Hive Employee Transportation And Cab Services is to deliver unparalleled quality products and services, characterized by friendliness and punctuality, while ensuring transparency in billing.

              </p>
              <h5>VISION</h5>
              <p>
              At Hive Employee Transportation And Cab Services, we envision becoming a world-class Travel Company by consistently exceeding customer expectations. We strive to achieve this vision by leveraging cutting-edge technology and delivering efficient services. Our commitment extends beyond conventional offerings to include regular home-to-office drops and pickups, employee transportation solutions, car rental services, event management for conferences and marriage parties, as well as bespoke holiday packages.

              </p>
            </Col>
            <Col xs={12} md={5} data-aos="fade-left">
              <img src={about2} className="img-fluid img-animation " alt="Hive Employee Transportation And Cab Services"></img>
            </Col>
          </Row>
          <Row className="mt-30 mb-30">
            <Col xs={12} md={12}>
              <div className="gray-divider"></div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={5} data-aos="fade-right">
              <img src={about} className="img-fluid img-animation" alt="Hive Employee Transportation And Cab Services"></img>
            </Col>
            <Col xs={12} md={7} data-aos="fade-left">
              <div className="main-title mt-3">
                <h4>Our Offerings</h4>
              </div>
              <p>
              Employee Transport services offering that includes Fleet Supply, Transport operations, and Manpower services.
              </p>
              <h5>Transport Operations</h5>
              <p>
              Manpower Services for Smooth and Efficient Transport Operations <br/>
At Hive Employee Transportation And Cab Services, we understand the critical role of manpower in ensuring seamless and efficient transport operations. Our dedicated team of professionals is committed to providing top-notch manpower services tailored to meet the specific needs of our clients.<br/>
From skilled chauffeurs and logistics coordinators to maintenance personnel and customer support representatives, our manpower services cover all aspects of transport operations. Each member of our team is meticulously trained, experienced, and equipped with the necessary skills to handle various tasks effectively.<br/>
With our manpower services, clients can rest assured that their transport operations are in capable hands. We strive to deliver excellence in every aspect of our services, ensuring smooth and hassle-free transportation for our clients.

              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
